module.exports = __webpack_public_path__ + "img/coins-6.37e37a94.png";